module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-1-95da692700990063a97a9341f922672f.png";